import React from "react";
import classes from "./Heading.module.scss";
import noise from "../../../media/noise.png";
import { scroller } from "react-scroll";
import {useNavigate} from "react-router-dom";

interface HeadingText {
  type: "white" | "blue";
  word: string;
}

interface HeadingProps {
  headingText: HeadingText[];
  text: string;
}

const Heading: React.FC<{
  startRowText: string;
  middleRowText: string;
  endRowText: string;
  message: string;
  buttonText: string;
  redirect?: boolean
}> = ({
  startRowText,
  middleRowText,
  endRowText,
  message,
  buttonText,
                       redirect
}): React.FC<HeadingProps> => {
  const navigate = useNavigate()

  const scheduleConsultationHandler = () => {
    if(!redirect)
    scroller.scrollTo("contact", {
      smooth: true,
      offset: -50,
      duration: 800,
    });

    else{
      navigate('/');
      setTimeout(()=> scroller.scrollTo("contact", {
        smooth: true,
        offset: -50,
        duration: 800,
      }), 300)
    }
  };

  return (
    <section className={classes["heading-container"]} id="nav-dark">
      <div className={`${classes["circle"]} ${classes["circle--4"]}`}></div>
      <div className={`${classes["circle"]} ${classes["circle--3"]}`}></div>
      <div className={`${classes["circle"]} ${classes["circle--2"]}`}></div>
      <div className={`${classes["circle"]} ${classes["circle--1"]}`}></div>
      <img src={noise} alt={"noise background"} className={classes["noise"]} />
      <div className={classes.container}>
        <div className={classes.heading}>
          <span className={classes.start}>{startRowText}</span>
          <span className={classes.middle}>{middleRowText}</span>
          <span className={classes.end}>{endRowText}</span>
        </div>
        <div className={classes.actions}>
          <p className={classes.text}>{message}</p>
          <button
            className={classes.button}
            onClick={scheduleConsultationHandler}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Heading;
